import React, { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { formatDateTime } from '~/utils/date';
import Container from '../../../components/Container';
import FixedBottom from '../../../components/FixedBottom';
import Header from '../../../components/Header';
import StickyHeader from '../../../components/StickyHeader';
import OrderDetailItemRow from '../OrderDetail/components/OrderDetailItemRow';
import OrderInfo from '../OrderDetail/components/OrderInfo';
import TotalSection from '../OrderDetail/components/TotalSection';
import BottomBar from './BottomBar';
import { Typography } from 'antd';
import ErrorBoundary from '~/App/ErrorBoundary';
import Loading from '~/App/components/Loading';
import { useSuspenseQuery } from '@tanstack/react-query';
import { api } from '@restaurant/api';
import { formatCurrency } from '@restaurant/utils';
import { PAYMENT_METHOD_TEXT } from '@restaurant/constants';

const OrderHistoryDetailContent = ({ id }: { id: string }) => {
  const { data: order } = useSuspenseQuery({
    queryKey: ['fetchOrderHistory', id],
    queryFn: () => {
      return api.fetchOrderById(id);
    },
  });

  return (
    <Container>
      <StickyHeader>
        <Header
          title={`Detail Order - No. ${order.orderNumber} (Sudah Dibayar)`}
        />
        <OrderInfo order={order} isPaid />
      </StickyHeader>
      <div className="pb-[320px]">
        {order.batches.map((batch, batchIndex) => {
          return (
            <div key={`${batchIndex}`}>
              {batch.map((item, itemIndex) => (
                <OrderDetailItemRow
                  orderId={order.orderId}
                  item={item}
                  batchIndex={batchIndex}
                  itemIndex={itemIndex}
                  key={`${batchIndex}-${itemIndex}-${item.menuId}`}
                  disabled={true}
                />
              ))}
            </div>
          );
        })}
        {order.tax && order.tax.isApplied && (
          <div className="flex justify-between items-center cursor-pointer mx-4">
            <Typography.Title level={5}>{order.tax.taxType}</Typography.Title>
            <Typography.Text>
              {formatCurrency(order.tax.amount)}
            </Typography.Text>
          </div>
        )}
      </div>
      <FixedBottom>
        <TotalSection order={order} />
        {order.payment ? (
          <div className="p-4 flex flex-col gap-1 bg-white">
            <div className="flex justify-between items-center">
              <p>Rounding</p>
              <p>{formatCurrency(order.payment.roundingAmount)}</p>
            </div>
            <div className="flex flex-col gap-2">
              {order.payment?.details?.map((item, index) => (
                <div className="flex justify-between items-center">
                  <div>
                    <p>
                      #{index + 1} {PAYMENT_METHOD_TEXT[item.method]}
                    </p>
                    <p className="text-[10px]">
                      {formatDateTime(item.timestamp)}
                    </p>
                  </div>
                  <p>{formatCurrency(item.amount)}</p>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p>Belum ada pembayaran</p>
        )}
        <BottomBar id={order.orderId} />
      </FixedBottom>
    </Container>
  );
};

const OrderHistoryDetail = () => {
  const { id } = useParams();
  if (!id) return <Navigate to="/order/history" />;
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loading />}>
        <OrderHistoryDetailContent id={id} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default OrderHistoryDetail;
